import { render, staticRenderFns } from "./ChuBei.vue?vue&type=template&id=01d30074&scoped=true&"
import script from "./ChuBei.vue?vue&type=script&lang=js&"
export * from "./ChuBei.vue?vue&type=script&lang=js&"
import style0 from "./ChuBei.vue?vue&type=style&index=0&id=01d30074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d30074",
  null
  
)

export default component.exports